import { useAxios } from "./api-axios";
import { useConfig } from "@/app-config";
import { toQueryString } from "@/regira_modules/utilities/http-utility";

export const getData = async (appId, query = {}) => {
  const { dataUrl } = useConfig();
  const queryString = toQueryString(query);
  const url = `${dataUrl.replace("{appId}", appId)}&${queryString}`;
  const apiAxios = useAxios();
  const response = await apiAxios.get(url);
  // debugging
  //response.data.siteSettings.skipPayment = true;
  if (Array.isArray(response.data.products)) {
    // Subtotaal hack
    const products = response.data.products.filter((x) => x.title != "Subtotaal");
    // process products
    processProducts(products, appId);
    response.data.products = products;
  }
  // debugging
  //response.data.siteSettings.ignoreMandatoryProducts = false;
  return response.data;
};

const processProducts = (products, appId) => {
  // set product images
  processProductImages(products, appId);
};
// replaces orderflow-imageUrl with (cached) webshop-imageUrl
const processProductImages = (products, appId) => {
  const { api, productImageUrl } = useConfig();
  // quickfix to refresh cached pictures
  const d = new Date();
  const timestamp = `${d.getFullYear()}${d.getMonth()}${d.getDate()}`;
  for (const product of products) {
    if (product.image != null) {
      product.image = {
        source: `${api}${productImageUrl.replace("{appId}", appId).replace("{productId}", product.id)}&v=${timestamp}`,
      };
    }
  }
};

export const findProduct = (products, id, product = null) => {
  return (
    products.find((p) => p.id === id) ||
    (product != null && products.find((p) => p.title == product.title && p.parentProductId === product.parentProductId && p.categoryId === product.categoryId))
  );
};
export const isRequired = (product, webshop) => {
  return !(webshop.ignoreMandatoryProducts || webshop.hasPreviousPaidOrder) && product.isRequired && product.parentProductId == null && !product.isUnavailable;
};
export const getRequiredProductNodes = (productTree) => productTree.filter((pn) => pn.value.isRequired && !pn.value.isUnavailable && pn.parent == null);

export const isProductSet = (productNode) => productNode.value.disablePartsSelection && productNode.children.length > 0;
export const isChoiceProductRoot = (productNode) => productNode.parent == null && !productNode.value.disablePartsSelection && productNode.children.length > 0;
export const isChoiceProduct = (productNode) =>
  productNode.parent != null && !productNode.value.disablePartsSelection && productNode.getRoot().children.length > 0;
export const isHeaderLine = (productNode) => productNode.value.isHeaderLine || productNode.value.costPerUnit == null;
